export default __webpack_public_path__ + "static/media/logo.9b928605.svg";